import { getDomain } from "./functions";

export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

// export const DOMAIN =
//   ENVIRONMENT === "test" ? "blakesshawn" : "cicod";
export const DOMAIN = ENVIRONMENT === "test" ? "blakesshawn" : getDomain();
export const PROD_BASE_URL = process.env.REACT_APP_PROD_BASE_URL;
export const DEV_BASE_URL = process.env.REACT_APP_DEV_BASE_URL;
export const STAGING_BASE_URL = process.env.REACT_APP_STAGING_BASE_URL;

export const BASE_URL =
  ENVIRONMENT === "production"
    ? PROD_BASE_URL
    : ENVIRONMENT === "staging"
    ? STAGING_BASE_URL
    : DEV_BASE_URL;

const url = window.location;
const pathnameSplit = url.pathname.split("/");

// export const FORM_NAME =
//   ENVIRONMENT === "test"
//     ? "Testing Form"
//     : decodeURIComponent(pathnameSplit[pathnameSplit.length - 1]).replace(
//         /%20/g,
//         " "
//       );


// export const getFormName = () => {
//   return ENVIRONMENT === "test"
//     ? "Meristem Loan Request Form"
//     : "Sales Channel Partner";
// }
export const getFormName = () => {
  return ENVIRONMENT === "test"
    ? "LINKED LIST FORM"
    : decodeURIComponent(pathnameSplit[pathnameSplit.length - 1]).replace(
        /%20/g,
        " "
      );
}
